import { useEffect, useState } from "react";
import { apiGetCached } from "../utils/api";

const ROADMAP_ENDPOINT = "/api/roadmap/";
const ROADMAP_TTL_MS = 5 * 60 * 1000;

export const useRoadmapSteps = () => {
  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const controller = new AbortController();

    const fetchRoadmapSteps = async () => {
      try {
        setLoading(true);
        const response = await apiGetCached(
          ROADMAP_ENDPOINT,
          { signal: controller.signal },
          { ttlMs: ROADMAP_TTL_MS }
        );

        if (!mounted) return;

        const data = Array.isArray(response.data) ? response.data : [];
        setSteps(data);
        setError(null);
      } catch (err) {
        if (controller.signal.aborted || !mounted) return;
        console.error("Error loading roadmap steps:", err);
        setError(err.message);
        setSteps([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchRoadmapSteps();

    return () => {
      mounted = false;
      controller.abort();
    };
  }, []);

  return { steps, loading, error };
};
